module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAAOVBMVEX///////////////////////////////9HcEz///////////////////////////////////////9ElBeKAAAAE3RSTlPIvyQ/NGIqeAAG0NQX4YgRtJagjWhsXAAAAIRJREFUCNdFj1kWxSAIQ6OigHO7/8UW7BvylXuAQwIRWXmj1p27eYiUUGcqiQFyLu1a4lpzJMEKt3w1a0duao6Ss4IR2B1fZyEDjQ7Pw9E4Hr5LiSo9fOZ5WIDu8/dei0n9Plf9/ZPAWLj+/1uH0JhvPuWR1PITwBSJUdPpY/0CgM3e7wFHVAbI2ajmsgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shijianbai.png
// module id = rQkZ
// module chunks = 1